

































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { GrantTypes, TwofaProviders } from "@/data/enums/tokens";
import { IToken } from "@/models/token";
import { Methods } from "@/models/methods";
import Context from "@/mixins/context";
import UPinInput from "@/components/app-base/UPinInput.vue";

@Component
export default class TwoFactorAuthentication extends Mixins(Context) {
  public declare $refs: {
    twofaCode: HTMLFormElement;
    pinInput: UPinInput;
  };

  // Props

  @Prop({ required: true })
  public token!: IToken;

  // Data

  public twofaCode = "";
  public isProcessing = false;

  // Methods

  @Watch("twofaCode")
  public onTwofaCodeChange(code) {
    if (code.length !== 6) return;
    this.check2Fa();
  }

  public async check2Fa() {
    this.isProcessing = true;
    try {
      const token: IToken = await this.$store.dispatch("api/call", {
        method: Methods.POST,
        path: "oauth/access_token",
        requestConfig: {
          handle401Error: false,
          data: await this.$store.dispatch("auth/prepareTokenPayload", {
            grant_type: this.isAdmin
              ? GrantTypes.TWOFA_ADMIN
              : GrantTypes.TWOFA,
            twofa_provider: TwofaProviders.GOOGLE,
            twofa_code: this.twofaCode
          })
        },
        callConfig: { customAccessToken: this.token.access_token }
      });
      token.created_at = this.$moment().unix();
      this.$emit("success", token);
    } catch {
      this.twofaCode = "";
      this.$nextTick(() => this.$refs.pinInput.init());
      this.$buefy.snackbar.open({
        message: this.$t("_.2fa_code_is_not_valid") as string,
        type: "is-danger",
        duration: 6000
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
